import React, { Component } from 'react';

class IconUserRole extends Component {
    render() {
        return (
            <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 40 45"
                style={{
                    width: "70%",
                    height: "70%"
                }}
            >
                <path
                    fill={this.props.isActive ? "#fff" : "#1D53A5"}
                    d="M16 15.8c8.616 0 15.6-3.492 15.6-7.8S24.616.2 16 .2C7.383.2.4 3.692.4 8s6.983 7.8 15.6 7.8zm12.194.041c1.222-.61 2.41-1.388 3.406-2.329v4.03A7.8 7.8 0 0023.186 30.1H21.85A5.85 5.85 0 0016 35.95v.008c0 .244 0 .447.005.803v.094c.032.555.11 1.107.237 1.648.208.89.608 2.057 1.378 3.255A33.08 33.08 0 0116 41.8C7.383 41.8.4 38.308.4 34V13.512c.996.941 2.184 1.718 3.406 2.33C7.06 17.468 11.377 18.4 16 18.4c4.623 0 8.939-.93 12.194-2.558zM29 19.7a5.2 5.2 0 11.334 10.395A5.2 5.2 0 0129 19.7zM18.6 35.95a3.251 3.251 0 013.25-3.25h14.3a3.251 3.251 0 013.25 3.25v.229c.003.184.005.369-.003.554-.024.396-.081.79-.171 1.177a7.775 7.775 0 01-1.196 2.686C36.605 42.624 33.9 44.4 29 44.4c-4.202 0-6.789-1.305-8.338-2.954a7.65 7.65 0 01-2.06-4.713l-.002-.775v-.008zm1.35 4.662l-1.569 1.097 1.568-1.097z"
                ></path>
            </svg>
        );
    }
}

export default IconUserRole;